export class ListIdpsResponse {
    'idps';
    'totalCount';
    'nextToken';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "idps",
            "baseName": "idps",
            "type": "Array<Idp>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIdpsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
